import type { FunctionComponent } from 'react';
import { DrawerPane } from 'owa-drawer';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { LazyTeamsChatList } from 'owa-teams-embed-client';
import type { OwaHeaderPaneProps } from '../../types/OwaHeaderPaneProps';
import { teamsChatHeaderButton } from '../buttons/OwaHeaderButton.locstring.json';
import { bodyContainer } from './TeamsChatPane.scss';

const defaultExport: FunctionComponent<OwaHeaderPaneProps> = observer(function TeamsChatPane(
    props
) {
    return (
        <DrawerPane
            paneId={props.paneId}
            headerText={loc(teamsChatHeaderButton)}
            bodyClassName={bodyContainer}
            preserveContentOnDismiss={true}
            role={'complementary'}
        >
            <LazyTeamsChatList />
        </DrawerPane>
    );
},
'TeamsChatPane');

export default defaultExport;
